import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { fontOverrides, } from '@awaze/design-system.design-tokens';
export const getUniqueFontWeights = (theme) => {
    return Array.from(new Set(Object.keys(theme)
        .filter((propertyName) => propertyName.includes('FontTextText') &&
        propertyName.includes('Weight'))
        .map((propertyName) => theme[propertyName])))
        .sort((n1, n2) => n1 - n2)
        .join(';');
};
export const FontTags = () => {
    const themeContext = useContext(ThemeContext);
    const headingFont = themeContext.FontHeadingHeading100FontFamily;
    const headingWeight = themeContext.FontHeadingHeading100FontWeight;
    const bodyFont = themeContext.FontTextText300FontFamily;
    const bodyWeights = getUniqueFontWeights(themeContext);
    return (_jsxs(_Fragment, { children: [_jsx(FontTag, { font: headingFont, weight: headingWeight }), _jsx(FontTag, { font: bodyFont, weight: bodyWeights })] }));
};
export const FontTag = ({ font, weight, }) => {
    const fontInOverrides = findFontInOverrides(fontOverrides, font);
    if (fontInOverrides) {
        return _jsx("link", { href: `${fontInOverrides.fontLocation}`, rel: "stylesheet" });
    }
    const formattedGoogleFontName = font.split(' ').join('+');
    return (_jsx("link", { href: `https://fonts.googleapis.com/css2?family=${formattedGoogleFontName}:wght@${weight}&display=swap`, rel: "stylesheet" }));
};
export const findFontInOverrides = (fontOverrides, font) => {
    return (Object.values(fontOverrides).find((override) => override.fontFamily === font) || null);
};
//# sourceMappingURL=fonts.js.map